import { api } from "../../gateways/unilabApi";

export async function getTranslations(payload) {
  return await api.get(`translation/${payload}`);
}
export async function getAllTranslations() {
  return await api.get(`translation/listFull`);
}
export async function getAllTranslationsExport() {
  return await api.get(`translation/listFullExport`);
}
export async function getTranslationsList(payload) {
  return await api.get(`translation/list/${payload}`);
}
export async function postUpdate(payload) {
  return await api.post(`translation/update`, payload);
}

export async function postUpdateAddAll(payload) {
  return await api.post(`translation/updateAddAll`, payload);
}

export async function postUpdateAddAllExport(payload) {
  return await api.post(`translation/updateAddAllExport`, payload);
}

export async function postRemove(payload) {
  return await api.post(`translation/destroy`, payload);
}

export async function postAdd(payload) {
  return await api.post(`translation/add?translation=` + payload);
}
export async function getExportModel() {
  return await api.get(`translation/exportModel`);
}
